<template>
  <div class="rastermap">
    <div
      v-if="tip"
      style="
        color: #db6504;
        margin: 0px 0px 10px 0px;
        padding: 5px;
        font-size: 0.65em;
        background-color: rgba(249, 115, 6, 0.05);
        border: 1px solid rgba(249, 115, 6, 0.25);
        text-align: left;
      "
      v-html="tip"
    ></div>

    <div class="row no-gutters" v-if="title && showTitle">
      <div class="col col-auto text-left">
        <h4>{{ title }}</h4>
      </div>

      <div
        class="col text-right"
        style="padding: 6px 5px 0px 0px"
        v-show="showOptions"
      >
        <ul class="cmd-group">
          <li class="title">
            <a href="#" @click.prevent="nextBackground">Background</a>
          </li>
          <li v-for="bg in backgroundLayers">
            <a
              href="#"
              :class="{ active: isActiveBackground(bg) }"
              @click.prevent="setBackground(bg)"
              >{{ bg.label }}</a
            >
          </li>
        </ul>

        <ul class="cmd-group">
          <li class="title">
            <a href="#" @click.prevent="nextOpacity">Opacity</a>
          </li>
          <li v-for="opacity in opacities" :key="opacity">
            <a
              href="#"
              :class="{ active: isActiveOpacity(opacity) }"
              @click.prevent="setOpacity(opacity)"
              >{{ opacity }}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div
      class="row no-gutters cmd"
      style="border-top: 1px dotted #ddd"
      v-show="showLayers"
    >
      <div class="col-sm-auto text-left layer-selection">
        <a
          v-for="layer in sanitizedLayers"
          href="#"
          :class="{
            active: isActiveLayer(layer),
            btn: true,
            'btn-layer': true,
          }"
          @click.prevent="loadLayer(layer)"
          :key="layer.label"
          >{{ layer.label }}</a
        >
      </div>
      <div v-if="loaded" class="col text-right layer-commands">
        <a
          v-if="downloadAble"
          v-bind:href="downloadUrl"
          title="Download current layer as GeoTIFF"
          class="btn btn-layer"
          ><i class="fas fa-download"></i
        ></a>
        <a
          v-if="layers.length > 1"
          href="#"
          class="btn btn-layer"
          @click.prevent="prevLayer"
          ><i class="fas fa-step-backward"></i
        ></a>
        <a
          v-if="layers.length > 1"
          href="#"
          class="btn btn-layer"
          @click.prevent="nextLayer"
          ><i class="fas fa-step-forward"></i
        ></a>
      </div>
    </div>

    <RasterMapTimeSlice
      v-bind:layer="layer"
      v-bind:loaded="loaded"
      @set-band="setBand"
    />

    <div class="row no-gutters">
      <div class="col">
        <div ref="map" class="map">
          <div
            class="leaflet-pane leaflet-map-pane"
            style="z-index: 99999999999"
          >
            <div
              v-show="contextLocation"
              class="contextPopup"
              ref="ctxMenu"
              :style="contextLocationStyle"
            >
              <div class="leaflet-popup-content-wrapper">
                <div class="leaflet-popup-content">
                  <a
                    v-for="context in contextMenu"
                    @click.prevent="
                      clickContext($event, context, contextLocation)
                    "
                    href="#"
                    class="btn btn-sm btn-light btn-block"
                  >
                    <template v-if="context == 'explore'">
                      <i class="bi bi-globe"></i> Explore imagery here
                    </template>
                    <template v-if="context == 'table'">
                      <i class="bi bi-window-plus"></i> Add to data table </template
                    ><!--
                <template v-if="context == 'info'">
                  <i class='bi bi-search'></i> More about this location
                </template>-->
                  </a>
                </div>
                <div class="locMark">Location: {{ contextLocationStr }}</div>
              </div>
              <div class="leaflet-popup-tip-container">
                <div class="leaflet-popup-tip"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-3"
        v-if="sideBar && sideBar['type'] == 'datatable'"
        style="
          font-size: 0.8em;
          background-color: #fff;
          margin-left: 3px;
          border-top: 1px solid #ddd;
          border-left: 1px solid #ddd;
          border-right: 1px solid #ddd;
          max-height: 450px;
          overflow: scroll;
        "
      >
        <div class="sidebar-contents">
          <a
            @click.prevent="closeSideBar"
            style="
              display: inline-block;
              position: absolute;
              right: 5px;
              top: 3px;
              margin: 6px;
            "
            class=""
            href="#"
            ><i class="bi bi-x-lg"></i
          ></a>
          <h4 style="">Data Table</h4>

          <RasterMapDataTable
            v-if="dataTableFiltered"
            v-bind:datatable="dataTableFiltered"
            v-bind:loaded="loaded"
          />
        </div>
      </div>

      <div
        class="col-5"
        v-if="sideBar && sideBar['type'] == 'explore'"
        style="
          font-size: 0.8em;
          background-color: #fff;
          margin-left: 3px;
          border-top: 1px solid #ddd;
          border-left: 1px solid #ddd;
          border-right: 1px solid #ddd;
          max-height: 450px;
          overflow: hidden;
        "
      >
        <div class="sidebar-contents">
          <a
            @click.prevent="closeSideBar"
            style="
              display: inline-block;
              position: absolute;
              right: 5px;
              top: 3px;
              margin: 6px;
            "
            class=""
            href="#"
            ><i class="bi bi-x-lg"></i
          ></a>
          <h4 style="">Explore Imagery</h4>

          <RasterMapExplore
            v-bind:factsheet="factsheet"
            v-bind:contextlocation="contextLocation"
            v-bind:sidebar="sideBar"
            v-bind:loaded="loaded"
            @set-explore-extent="setExploreExtent"
          />
        </div>
      </div>

      <div
        class="col-5"
        v-if="sideBar && sideBar['type'] == 'swc_instream'"
        style="
          font-size: 0.8em;
          background-color: #fff;
          margin-left: 3px;
          border-top: 1px solid #ddd;
          border-left: 1px solid #ddd;
          border-right: 1px solid #ddd;
          max-height: 450px;
          overflow: scroll;
        "
      >
        <div class="sidebar-contents">
          <a
            @click.prevent="closeSideBar"
            style="
              display: inline-block;
              position: absolute;
              right: 5px;
              top: 3px;
              margin: 6px;
            "
            class=""
            href="#"
            ><i class="bi bi-x-lg"></i
          ></a>

          <h4 style="background-color: #fff; padding-top: 0px">
            <i class="bi bi-water"></i> Stream Classification
          </h4>

          <table class="table table-sm">
            <tr>
              <td><strong>Aridity Zone:</strong></td>
              <td>{{ sideBar["swc_instream_classification"]["class_ai"] }}</td>
            </tr>
            <tr>
              <td><strong>Lithology and stream sediment:</strong></td>
              <td>
                {{
                  sideBar["swc_instream_classification"][
                    "class_lithology_and_stream_sediment"
                  ]
                }}
              </td>
            </tr>
            <tr>
              <td><strong>Slope (%):</strong></td>
              <td>
                {{ sideBar["swc_instream_classification"]["class_slope"] }}
              </td>
            </tr>
            <tr>
              <td>
                <strong><nobr>Stream Order:</nobr></strong>
              </td>
              <td>
                {{
                  sideBar["swc_instream_classification"]["class_stream_order"]
                }}
              </td>
            </tr>
          </table>

          <h4>Instream Water Harvesting</h4>
          <table class="table table-sm">
            <tr>
              <td>
                <strong>Sanddams and subsurface dams:</strong><br /><span
                  v-html="
                    ndash(
                      sideBar['swc_instream_classification']['instream_dams']
                    )
                  "
                ></span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Other instream interventions:</strong><br /><span
                  v-html="
                    ndash(
                      sideBar['swc_instream_classification']['instream_other']
                    )
                  "
                ></span>
              </td>
            </tr>
          </table>

          <h4>Groundwater Recharge (Managed Aquifer Recharge)</h4>
          <table class="table table-sm">
            <tr>
              <td>
                <strong>Shallow groundwater storage:</strong><br /><span
                  v-html="
                    ndash(
                      sideBar['swc_instream_classification'][
                        'groundwater_shallow'
                      ]
                    )
                  "
                ></span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Deep groundwater recharge:</strong><br /><span
                  v-html="
                    ndash(
                      sideBar['swc_instream_classification']['groundwater_deep']
                    )
                  "
                ></span>
              </td>
            </tr>
          </table>

          <span
            style="
              color: #ccc;
              font-weight: normal;
              display: block;
              padding-left: 4px;
            "
            >Code:
            {{ sideBar["swc_instream_classification"]["uniq_code"] }}</span
          >
        </div>
      </div>

      <div
        class="col-5"
        v-if="sideBar && sideBar['type'] == 'swcinfo'"
        style="
          font-size: 0.8em;
          background-color: #fff;
          margin-left: 3px;
          border-top: 1px solid #ddd;
          border-left: 1px solid #ddd;
          border-right: 1px solid #ddd;
          max-height: 450px;
          overflow: scroll;
        "
      >
        <a
          @click.prevent="closeSideBar"
          style="
            display: inline-block;
            position: absolute;
            right: 5px;
            top: 3px;
            margin: 6px;
          "
          class=""
          href="#"
          ><i class="bi bi-x-lg"></i
        ></a>

        <div
          class="sidebar-contents"
          @click.prevent="sideBarClick"
          :style="sideBarStyle(sideBar['interventions']['HEX'])"
        >
          <h4 style="background-color: #fff; padding-top: 0px">
            <i class="bi bi-geo-fill"></i> Land Classification
          </h4>

          <table class="table table-sm">
            <tr>
              <td><strong>Coordinates:</strong></td>
              <td>
                {{ clickLocation.lat.toFixed(6) }},
                {{ clickLocation.lng.toFixed(6) }}
              </td>
            </tr>
            <tr>
              <td><strong>Aridity Zone:</strong></td>
              <td>{{ sideBar["interventions"]["AI zone"] }}</td>
            </tr>
            <tr>
              <td><strong>Land Cover:</strong></td>
              <td>{{ sideBar["interventions"]["Land cover"] }}</td>
            </tr>
            <tr>
              <td><strong>Slope (%):</strong></td>
              <td>{{ sideBar["interventions"]["Slope (%)"] }}</td>
            </tr>
            <tr>
              <td><strong>Soils:</strong></td>
              <td>{{ sideBar["interventions"]["Soil"] }}</td>
            </tr>
          </table>

          <h4>Soil and Water Conservation Interventions</h4>
          <table class="table table-sm">
            <tr>
              <td>
                <strong>Sustainable agro-ecological land use:</strong
                ><br /><span
                  v-html="
                    ndash(
                      sideBar['interventions'][
                        'Sustainable agro-ecological land use'
                      ]
                    )
                  "
                ></span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Management interventions:</strong><br /><span
                  v-html="
                    ndash(sideBar['interventions']['Management interventions '])
                  "
                ></span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Agronomic measures:</strong><br /><span
                  v-html="ndash(sideBar['interventions']['Agronomic measures'])"
                ></span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Physical SWC interventions:</strong><br /><span
                  v-html="
                    ndash(
                      sideBar['interventions']['Physical SWC interventions']
                    )
                  "
                ></span>
              </td>
            </tr>
          </table>

          <h4>Storage and stream water harvesting</h4>
          <table class="table table-sm">
            <tr>
              <td>
                <strong>Offstream:</strong><br /><span
                  v-html="ndash(sideBar['interventions']['Offstream'])"
                ></span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Instream:</strong><br /><span
                  v-html="ndash(sideBar['interventions']['Instream'])"
                ></span>
              </td>
            </tr>

            <h4>Geology</h4>
            <tr>
              <td>
                <strong>Lithology:</strong><br /><span
                  v-html="ndash(sideBar['geology']['lithology'])"
                ></span
                >.

                <span v-if="sideBar['geology']['suitability'] == 1"
                  >Rock with low permeabilty, sediment with high sand
                  content.</span
                >
                <span v-if="sideBar['geology']['suitability'] == 2"
                  >Rock with medium or unknown permeability, sediment with
                  medium/high sand content.</span
                >
                <span v-if="sideBar['geology']['suitability'] == 3"
                  >Rock with high or unknown permeability, sediment with low
                  sand content.</span
                >
              </td>
            </tr>
            <tr>
              <td>
                <strong>Suitability for sand and subsurface dams:</strong><br />

                <span v-if="sideBar['geology']['suitability'] == 1"
                  >High potential for sanddams and subsurface dams in streambeds
                  (alluvial sediments) and shallow groundwater storage in the
                  overburden; Low potential for deep groundwater recharge.</span
                >
                <span v-if="sideBar['geology']['suitability'] == 2"
                  >Medium potential for sanddams and subsurface dams in
                  streambeds (alluvial sediments) and shallow groundwater
                  storage in the overburden; Variable potential for deep
                  groundwater recharge.</span
                >
                <span v-if="sideBar['geology']['suitability'] == 3"
                  >Low potential for sanddams and subsurface dams in streambeds
                  (alluvial sediments) and shallow groundwater storage in the
                  overburden; Variable potential for deep groundwater
                  recharge.</span
                >
              </td>
            </tr>
          </table>
          <span
            style="
              color: #ccc;
              font-weight: normal;
              display: block;
              padding-left: 4px;
            "
            >Code: {{ sideBar["interventions"]["Code"] }}</span
          >
        </div>
      </div>
    </div>

    <div
      class="row no-gutters"
      v-if="backgroundLegendShow"
      style="pointer-events: none"
    >
      <div
        class="col col-4 offset-8"
        style="
          position: relative;
          top: -206px;
          margin-bottom: -200px;
          height: 200px;
          z-index: 99999999999;
          border: 0px solid red;
          font-size: 0.9em;
        "
      >
        <div
          style="
            position: absolute;
            bottom: 0;
            right: 6px;
            padding: 0px;
            width: 100%;
            text-align: left;
            background-color: rgba(250, 250, 250, 0.9);
            padding: 5px;
            border: 1px solid #ccc;
          "
        >
          <RasterMapLegend
            v-if="background['legend']"
            v-bind:legend="background['legend']"
            v-bind:layout="layout"
            v-bind:loaded="loaded"
            isBackground="true"
          />
        </div>
      </div>
    </div>

    <template v-if="extendedlegend || extendedLegendImage">
      <RasterMapExtendedLegend
        v-if="extendedlegend"
        v-bind:extendedlegend="extendedlegend"
        v-bind:loaded="loaded"
        @set-sidebar="setSideBar"
      />

      <div
        v-if="extendedLegendImage"
        style="width: 100%; height: 250px; overflow: scroll"
      >
        <img :src="extendedLegendImage" style="width: 100%" />
      </div>
    </template>
    <template v-else>
      <div class="row no-gutters" style="">
        <div v-bind:class="legendClass">
          <div v-if="loaded" class="legend-wrapper">
            <RasterMapLegend
              v-bind:legend="legend"
              v-bind:layout="layout"
              v-bind:loaded="loaded"
            />
          </div>
        </div>
        <div v-bind:class="descriptionClass">
          <div class="legend-wrapper legend-description">
            <slot></slot>
            <div
              style="font-size: 0.6em; color: #222; padding: 1px 4px"
              v-html="layer['long_description']"
            ></div>
          </div>
        </div>
      </div>
    </template>

    <div class="row no-gutters" v-if="attribution">
      <p class="attribution">{{ attribution }}</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import RasterMapLegend from "@/components/factsheet/RasterMapLegend.vue";
import RasterMapExtendedLegend from "@/components/factsheet/RasterMapExtendedLegend.vue";
import RasterMapTimeSlice from "@/components/factsheet/RasterMapTimeSlice.vue";
import RasterMapDataTable from "@/components/factsheet/RasterMapDataTable.vue";
import RasterMapExplore from "@/components/factsheet/RasterMapExplore.vue";

import Leaflet from "leaflet";
import "leaflet/dist/leaflet.css";
import omnivore from "@mapbox/leaflet-omnivore";

export default {
  name: "RasterMap",
  components: {
    RasterMapLegend,
    RasterMapTimeSlice,
    RasterMapExtendedLegend,
    RasterMapDataTable,
    RasterMapExplore,
  },
  props: [
    "location",
    "source",
    "title",
    "description",
    "layout",
    "tip",
    "attribution",
    "factsheet",
    "loaded",
    "layers",
    "backgrounds",
    "hideOptions",
    "hideLayers",
    "hideTitle",
    "extendedlegend",
    "contextMenu",
    "clickAction",
    "extendedLegendImage",
    "overlays",
    "legendFirst",
  ],
  data() {
    return {
      showOptions: this.hideOptions ? false : true,
      showLayers: this.hideLayers ? false : true,
      showTitle: this.hideTitle ? false : true,
      legend: null,
      legendBackground: null,
      legendOnLeft: this.legendFirst == true ? true : false,
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      layer: null,
      data: null,
      mapBackground: null,
      backgroundLayers: [],
      background: null,
      backgroundLegendShow: false,
      opacities: [10, 50, 100],
      opacity: 100,
      layerTimeSlice: 1,
      sideBar: null,
      dataTable: [],
      contextLocation: null,
      clickLocation: null,
      clickLocationData: {
        type: "swcinfo",
        geology: null,
        interventions: null,
      },
      clickOverlay: null,
    };
  },
  created() {
    this.layer = this.layers[0];
  },
  updated() {},
  mounted() {
    // Create the map
    this.map = L.map(this.$refs.map, {
      attributionControl: false,
      scrollWheelZoom: false,
    });
    L.control.scale().addTo(this.map);

    this.map.on("preclick", (e) => {
      this.contextLocation = null;
    });
    this.map.on("movestart", (e) => {
      this.contextLocation = null;
    });

    if (this.enableContextMenu) {
      this.map.on("contextmenu", (e) => {
        console.log("Context menu on: " + e.latlng);
        this.contextLocation = e.latlng;
      });
    }

    if (this.enableClickAction) {
      this.map.on("click", (e) => {
        console.log("Clickaction on map:");
        this.clickLocation = e.latlng;
      });
    }

    // Create relevant panes
    this.map.createPane("background");
    this.map.getPane("background").style.pointerEvents = "none";
    this.map.getPane("background").style.zIndex = 200;

    this.map.createPane("data");
    this.map.getPane("data").style.zIndex = 200;

    this.map.createPane("foreground");
    this.map.getPane("foreground").style.pointerEvents = "none";
    this.map.getPane("foreground").style.zIndex = 900;

    this.map.createPane("extent");
    this.map.getPane("extent").style.pointerEvents = "none";
    this.map.getPane("extent").style.zIndex = 950;

    this.map.createPane("datatable");
    this.map.getPane("datatable").style.pointerEvents = "none";
    this.map.getPane("datatable").style.zIndex = 1000;

    this.extentFeatures = L.featureGroup({ pane: "extent" }).addTo(this.map);

    this.dataTableFeatures = L.featureGroup({ pane: "datatable" }).addTo(
      this.map
    );

    // Load backgrounds from factsheet config
    var backgrounds = this.factsheet["info"]["config"]["background_layers"];
    if (backgrounds) {
      _.forEach(backgrounds, (background) => {
        this.backgroundLayers.push(background);
      });
      console.log("Set bg to: " + backgrounds[0]["id"]);
      this.background = backgrounds[0];
    }

    this.loadMap();
    this.loadLegend();
    this.loadLayer(this.layers[0]);
    if (this.overlays) {
      this.loadOverlays();
    }
  },
  watch: {
    loaded() {
      this.loadMap();
      this.loadLegend();
    },
    background() {
      if (this.mapBackground) {
        this.map.removeLayer(this.mapBackground);
      }
      if (this.background["type"] == "xyzlayer") {
        var url =
          process.env.VUE_APP_API +
          "/tools/layer/" +
          this.background["name"] +
          "/v" +
          this.background["version"] +
          "?z={z}&x={x}&y={y}";
        this.mapBackground = L.tileLayer(url, {
          attribution: "",
          maxZoom: 22,
          pane: "background",
        }).addTo(this.map);
      }
      if (this.background["type"] == "wmslayer") {
        var url =
          process.env.VUE_APP_API +
          "/tools/layer/" +
          this.background["name"] +
          "/v" +
          this.background["version"];
        this.mapBackground = L.tileLayer
          .wms(url, {
            attribution: "",
            maxZoom: 22,
            tileSize: 512,
            pane: "background",
          })
          .addTo(this.map);
      }
      if (this.background["type"] == "qgislayer") {
        var url =
          process.env.VUE_APP_API +
          "/tools/layer/" +
          this.background["name"] +
          "/v" +
          this.background["version"];
        this.mapBackground = L.tileLayer
          .wms(url, {
            attribution: "",
            maxZoom: 22,
            tileSize: 1024,
            pane: "background",
          })
          .addTo(this.map);
      }
      if (this.background["legend"]) {
        this.backgroundLegendShow = true;
      } else {
        this.backgroundLegendShow = false;
      }
    },
    opacity() {
      this.data.setOpacity(this.opacity / 100);
    },
    layerTimeSlice() {
      console.log("Layer timeslice updated!!!");
    },
    layer() {
      console.log("Updating active layer...");
    },
    sideBar() {},
    clickLocation() {
      //console.log("Updating click location: "+this.clickLocation)
      if (this.clickLocation != null) {
        var pointUrl =
          process.env.VUE_APP_API +
          "/tools/raster/point/" +
          this.factsheet["identifier"] +
          "/" +
          this.layer["dataset_id"] +
          "/" +
          this.layer["filename"] +
          "~/point.json?lat=" +
          this.clickLocation.lat +
          "&lng=" +
          this.clickLocation.lng;
        this.$axios.get(pointUrl).then((response) => {
          console.log(
            "Matching value " +
              response.data["data"][0] +
              " to extended legend:"
          );

          var extendedLegend =
            this.factsheet.data["geofolio_rwh"]["extended_legend"];
          _.forEach(extendedLegend["values"], (row) => {
            if (row["Code"] == response.data["data"][0]) {
              this.clickLocationData["interventions"] = row;
            }
          });

          this.setSideBar(this.clickLocationData);
        });
        var geologyUrl =
          process.env.VUE_APP_API +
          "/tools/extra/geology-africa?lat=" +
          this.clickLocation.lat +
          "&lng=" +
          this.clickLocation.lng;
        this.$axios.get(geologyUrl).then((response) => {
          /* find the corresponding info */
          let geology = {};
          geology["lithology"] = response.data["LITHO"];

          var geologyClasses =
            this.factsheet.data["geofolio_rwh"]["geology_classification"];

          _.forEach(geologyClasses, (row) => {
            if (parseInt(row["Code"]) == response.data["CODE_LEG"]) {
              geology["suitability"] = parseInt(row["Reclass"]);
            }
          });
          this.clickLocationData["geology"] = geology;
          this.setSideBar(this.clickLocationData);
        });
      }
    },
    dataTableFiltered() {
      //console.log("datatable updated!")
      this.dataTableFeatures.clearLayers();
      this.dataTableFiltered.forEach((item, n) => {
        L.marker([item.lat, item.lng], {
          icon: L.divIcon({
            className: "datatable-icon",
            html: n + 1 + "<div class='arrow'></div>",
          }),
        }).addTo(this.dataTableFeatures);
      });
    },
  },
  filters: {},
  methods: {
    streamClassification(magic_number, column) {
      if (
        classification.hasOwnProperty(magic_number) &&
        classification[magic_number].hasOwnProperty(column)
      ) {
        var val = classification[magic_number][column];
        if (val == "0") {
          return "";
        } else {
          return val;
        }
      }
      return "";
    },
    streamBgStyle(layer) {
      var weight = 3;
      var opacity = 0.8;
      if (layer.properties.ord_stra == 2) {
        weight = 4;
        opacity = 0.9;
      }
      if (layer.properties.ord_stra >= 3) {
        weight = 5;
        opacity = 1.0;
      }
      var style = {
        color: "#ffffff",
        weight: weight,
        opacity: opacity,
      };
      return style;
    },
    loadOverlays() {
      _.forEach(this.overlays, (overlay, n) => {
        // {
        //           'title': 'In-stream',
        //           'dataset': 'geofolio_swc_instream',
        //           'layer': 'streams.geojson',
        //           'onclick': 'swc_instream_panel'
        //         }
        var datasetId = this.factsheet.dataset_ids[overlay["dataset"]];
        var streamsUrl =
          process.env.VUE_APP_API +
          "/data/factsheet/" +
          this.factsheet.identifier +
          "/data/" +
          datasetId +
          "/streams.geojson";
        this.$axios.get(streamsUrl).then((response) => {
          var opts = {
            style: (layer) => {
              var style = {
                color: "#417de8", //"#26ceff",
                weight: 2,
                opacity: 1,
                fillOpacity: 0,
              };
              if (layer.properties.ord_stra == 1) {
                style["dashArray"] = "3, 3";
                style["dashOffset"] = "3";
                style["color"] = "#436ab0";
              }
              if (layer.properties.ord_stra == 2) {
                style["weight"] = 2;
              }
              if (layer.properties.ord_stra >= 3) {
                style["weight"] = 3;
              }
              return style;
            },
            pane: "foreground",
            interactive: false,
          };
          var bgOpts = {
            style: (layer) => {
              return this.streamBgStyle(layer);
            },
            onEachFeature: (feature, layer) => {
              layer.on({
                click: (e) => {
                  if (
                    !this.factsheet.data.hasOwnProperty("geofolio_swc_instream")
                  ) {
                    return;
                  }
                  if (
                    !this.factsheet.data[
                      "geofolio_swc_instream"
                    ].hasOwnProperty("swc_instream_classification")
                  ) {
                    return "";
                  }
                  var classification =
                    this.factsheet.data["geofolio_swc_instream"][
                      "swc_instream_classification"
                    ];
                  this.sideBar = {
                    type: "swc_instream",
                    swc_instream_classification:
                      classification[
                        layer.feature.properties["calc_swc_number"]
                      ],
                  };
                },
                mouseover: (e) => {
                  layer.setStyle({
                    weight: 9,
                    color: "white",
                    opacity: 1,
                  });
                },
                mouseout: (e) => {
                  layer.setStyle(this.streamBgStyle(layer.feature));
                },
              });
            },
            pane: "foreground",
            bubblingMouseEvents: false,
          };

          this.riversBg = new L.geoJSON(response.data, bgOpts).addTo(this.map);
          this.rivers = new L.geoJSON(response.data, opts).addTo(this.map);
        });
      });
    },
    sideBarClick(e) {
      if (e.target.matches(".sidebar-explainer")) {
        var term =
          this.factsheet.data["geofolio_rwh"]["terms"][
            parseInt(e.target.getAttribute("href")) - 1
          ];
        if (term) {
          var html = "<h2>" + term["term"] + "</h2>";
          html += "<p>" + term["description"] + "</p>";
          if (term["link"]) {
            html +=
              "<p><a target='_blank' href='" +
              term["link"] +
              "'>More information&nbsp;&nbsp;<i class='bi bi-box-arrow-up-right'></i></a></p>";
          }
          if (term["example"]) {
            html +=
              "<p><a target='_blank' href='" +
              term["example"] +
              "'>Exampes&nbsp;&nbsp;<i class='bi bi-box-arrow-up-right'</a></p>";
          }
          this.explainerContent(html);
        }
      }
    },
    ndash: function (value) {
      if (!value) return "&ndash;";
      var terms = this.factsheet.data["geofolio_rwh"]["terms"];
      var result = "";
      _.forEach(terms, (term, n) => {
        var regEx = new RegExp(term["term"], "ig");
        var replaceMask =
          "<a class='sidebar-explainer' href='" +
          (n + 1) +
          "'>" +
          term["term"] +
          "</a>";
        value = value.replace(regEx, replaceMask);
      });
      return value;
    },
    sideBarStyle: function (color) {
      return "border-left:10px solid " + color;
    },
    clickContext(e, c, location) {
      if (c == "table") {
        this.contextMenuTable(location);
      }
      if (c == "explore") {
        this.contextMenuExplore(location);
      }
      this.contextLocation = null;
      e.stopPropagation();
    },
    contextMenuTable(location) {
      var pointUrl =
        process.env.VUE_APP_API +
        "/tools/raster/point/" +
        this.factsheet["identifier"] +
        "/" +
        this.layer["dataset_id"] +
        "/" +
        this.layer["filename"] +
        "~/point.json?lat=" +
        location.lat +
        "&lng=" +
        location.lng;
      this.$axios.get(pointUrl).then((response) => {
        var tableEntry = response.data;
        tableEntry["filename"] = this.layer["filename"];
        this.dataTable.push(tableEntry);
        this.sideBar = {
          type: "datatable",
        };
      });
    },
    contextMenuExplore(location) {
      this.sideBar = {
        type: "explore",
        location: location,
        zoom: this.map.getZoom(),
      };
    },
    setBand(b) {
      this.layer["time_slice"] = b;
      this.loadLayer(this.layer);
    },
    setSideBar(html) {
      this.sideBar = html;
    },
    setExploreExtent(extent) {
      this.extentFeatures.clearLayers();
      var latlngs = [];
      latlngs.push(extent.getSouthWest());
      latlngs.push(extent.getSouthEast());
      latlngs.push(extent.getNorthEast());
      latlngs.push(extent.getNorthWest());

      var polygon = L.polygon(latlngs, {
        color: "#000",
        weight: 2,
        fillOpacity: 0.0,
        fillColor: "#9a8fcd",
      });
      polygon.addTo(this.extentFeatures);
    },
    closeSideBar() {
      this.sideBar = null;
      this.extentFeatures.clearLayers();
    },
    loadMap() {
      if (!this.loaded) {
        return;
      }
      _.cloneDeep(this.location.layer).addTo(this.map);
      this.map.fitBounds(this.location.bounds);
      this.loadLegend();
    },
    loadLegend() {
      if (this.layer) {
        /* Either fetch the legend, or use the one of the current layer. */
        if (this.layer && this.layer.hasOwnProperty("legend")) {
          if (this.layer["legend"]) {
            this.legend = this.layer["legend"];
          } else {
            var legendUrl =
              process.env.VUE_APP_API +
              "/tools/raster/legend/" +
              this.factsheet["identifier"] +
              "/" +
              this.layer["dataset_id"] +
              "/" +
              this.layer["filename"] +
              "~/legend.json";

            this.$axios.get(legendUrl).then((response) => {
              this.legend = response.data;
            });
          }
        }
      }
    },
    loadLayer(layer) {
      this.layer = layer;
      if (this.data) {
        this.map.removeLayer(this.data);
      }
      if (
        this.layer["type"] == "qgislayer" ||
        this.layer["type"] == "wmslayer"
      ) {
        var url =
          process.env.VUE_APP_API +
          "/tools/layer/" +
          this.layer["name"] +
          "/v" +
          this.layer["version"] +
          "?z={z}&x={x}&y={y}";
        this.data = L.tileLayer
          .wms(url, {
            attribution: "",
            maxZoom: 22,
            tileSize: 512,
            id: "data",
            pane: "data",
          })
          .addTo(this.map);
        this.data.setUrl(url);
      }
      if (
        this.layer["type"] == "xyzlayer" ||
        this.layer["type"] == "datalayer" ||
        this.layer["type"] == "attachment"
      ) {
        var dataUrl = "";
        if (this.layer["type"] == "attachment") {
          dataUrl =
            process.env.VUE_APP_API +
            "/tools/raster/tile/" +
            this.factsheet["identifier"] +
            "/" +
            this.layer["dataset_id"] +
            "/" +
            this.layer["source"] +
            "~/tile/{z}/{x}/{y}.png";
        }
        if (this.layer["type"] == "datalayer") {
          if (this.layer.hasOwnProperty("dataset_id")) {
            dataUrl =
              process.env.VUE_APP_API +
              "/tools/raster/tile/" +
              this.factsheet["identifier"] +
              "/" +
              this.layer["dataset_id"] +
              "/" +
              this.layer["filename"] +
              "~/tile/{z}/{x}/{y}.png";
            if (this.layer.hasOwnProperty("time_slice")) {
              dataUrl += "?b=" + this.layer["time_slice"];
            }
          } else {
            dataUrl =
              process.env.VUE_APP_API +
              "/tools/raster/tile/" +
              this.factsheet["identifier"] +
              "/" +
              this.layer["dataset_id"] +
              "/" +
              this.layer["source"] +
              "~/tile/{z}/{x}/{y}.png";
          }
        }
        if (this.layer["type"] == "xyzlayer") {
          dataUrl = this.layer["url"];
        }
        this.data = L.tileLayer(dataUrl, {
          attribution: "",
          maxZoom: 18,
          id: "data",
          pane: "data",
        }).addTo(this.map);
        this.data.setUrl(dataUrl);
      }
      this.loadLegend();
    },
    setBackground(background) {
      this.background = background;
    },
    isActiveBackground(background) {
      return this.background["id"] == background["id"];
    },
    toggleBackgroundLegend() {
      if (this.backgroundLegendShow) {
        this.backgroundLegendShow = false;
      } else {
        this.backgroundLegendShow = true;
      }
    },
    nextBackground() {
      var current = 0;
      for (let i = 0; i < this.backgroundLayers.length; i++) {
        if (this.backgroundLayers[i]["id"] == this.background["id"]) {
          var current = i;
        }
      }
      var next = (current + 1) % this.backgroundLayers.length;
      this.background = this.backgroundLayers[next];
    },
    nextOpacity() {
      var current = this.opacities.indexOf(this.opacity);
      var next = (current + 1) % this.opacities.length;
      this.opacity = this.opacities[next];
    },
    currentLayer() {
      var layerIds = [];
      _.forEach(this.sanitizedLayers, (layer) => {
        layerIds.push(layer["id"]);
      });
      return layerIds.indexOf(this.layer["id"]);
    },
    nextLayer() {
      var next = (this.currentLayer() + 1) % this.layers.length;
      this.layer = this.layers[next];
    },
    prevLayer() {
      var prev = this.currentLayer() - 1;
      if (prev < 0) {
        prev = this.layers.length - 1;
      }
      this.layer = this.layers[prev];
    },
    isActiveOpacity(opacity) {
      return this.opacity == opacity;
    },
    isActiveLayer(layer) {
      return this.layer["id"] == layer["id"];
    },
    setOpacity(opacity) {
      this.opacity = opacity;
    },
  },
  computed: {
    enableContextMenu() {
      if (this.contextMenu != null && this.contextMenu != []) {
        return true;
      } else {
        return false;
      }
    },
    enableClickAction() {
      if (this.clickAction != null && this.clickAction != []) {
        return true;
      } else {
        return false;
      }
    },
    contextLocationStyle() {
      var base =
        "width:200px;border-color:1px solid red;position:absolute;left:-100px;font-size:1.1em;padding:0px;";
      if (this.contextLocation != null && this.map != null) {
        var origin = this.map.getPixelOrigin();
        var coords = this.map.latLngToContainerPoint(this.contextLocation);
        return (
          base +
          "transform: translate3d(" +
          coords.x +
          "px, " +
          coords.y +
          "px, 0px); bottom: 10px; left: -100px;"
        );
      } else {
        return base + "display:none;";
      }
    },
    contextLocationStr() {
      if (this.contextLocation != null && this.map != null) {
        return (
          this.contextLocation.lat.toFixed(4) +
          ", " +
          this.contextLocation.lng.toFixed(4)
        );
      } else {
        return "?";
      }
    },
    downloadUrl() {
      if (this.layer == null) {
        return "";
      } else {
        var url =
          process.env.VUE_APP_API +
          "/data/factsheet/" +
          this.factsheet["identifier"] +
          "/data/" +
          this.layer["dataset_id"] +
          "/" +
          this.layer["filename"];
        return url;
      }
    },
    downloadAble() {
      if (this.layer.hasOwnProperty("source")) {
        return true;
      } else {
        return false;
      }
    },
    legendClass() {
      return (
        "col-sm-12 col-md-12 col-lg-" +
        (this.layout ? this.layout.legendWidth : 6)
      );
    },
    descriptionClass() {
      return (
        "col-sm-12 col-md-12 col-lg-" +
        (this.layout ? this.layout.descriptionWidth : 6)
      );
    },
    dataTableFiltered() {
      var filteredRows = [];
      _.forEach(this.dataTable, (row) => {
        if (row["filename"] == this.layer["filename"]) {
          filteredRows.push(row);
        }
      });
      return filteredRows;
    },
    sanitizedLayers() {
      /*
        This fixes some compatibility issues with the old ways of supplying
        layer information.
        */
      var saneLayers = [];
      _.forEach(this.layers, (layer) => {
        if (!layer.hasOwnProperty("time")) {
          layer["time"] = "none";
          layer["time_slice"] = 1;
        }
        if (layer.hasOwnProperty("source")) {
          /* A source is defined, infer the other required properties from there... */
          //            layer["dataset_name"] = layer["source"].split("/")[1];

          layer["type"] = "datalayer";
          layer["description"] = layer["title"];
          layer["label"] = layer["title"];
          layer["id"] = layer["title"];
          layer["legend"] = undefined;
          if (!layer.hasOwnProperty("long_description")) {
            layer["long_description"] = undefined;
          }

          if (
            !layer.hasOwnProperty("filename") ||
            !layer.hasOwnProperty("path")
          ) {
            /* No filename or dataset provided. Instead derive from source. */
            var parts = layer["source"].split("/", 3);
            layer["filename"] = parts[2];

            /* check if we can find the dataset path... */
            if (this.factsheet.dataset_ids.hasOwnProperty(parts[1])) {
              layer["dataset_id"] = this.factsheet.dataset_ids[parts[1]];
              layer["dataset_key"] = parts[1];
              layer["dataset_path"] =
                this.factsheet.dataset_paths[layer["dataset_key"]];
            }
          }
        }
        saneLayers.push(layer);
      });
      return saneLayers;
    },
  },
};
</script>
<style>
.leaflet-container {
  cursor: crosshair;
}
div.datatable-icon {
  border-top: 2px solid #fff;
  color: #444;
  width: 16px !important;
  padding-top: 1px;
  height: 18px !important;
  text-align: center;
  font-weight: 600;
  background-color: #fff;
  position: absolute;
  left: -3px;
  top: -20px;
}
div.datatable-icon div.arrow {
  width: 16px;
  height: 16px;
  position: relative;
  top: -3px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent; /* 40px height (20+20) */
  border-top: 8px solid white;
}
div.contextPopup {
  border-radius: 0px;
  background-color: #fff;
  width: 200px;
}
div.contextPopup div.locMark {
  color: #888;
  padding: 6px;
  font-size: 0.9em;
  font-weight: bold;
}
div.contextPopup div.locMark i {
  float: right;
}
div.contextPopup div.leaflet-popup-content-wrapper {
  border-radius: 0px;
}
div.contextPopup div.leaflet-popup-content {
  padding: 0px;
  margin: 0px;
}
div.contextPopup a {
  width: 100%;
  margin: 0px !important;
  font-size: 1em;
  text-align: left;
  border: none;
}
div.contextPopup a:hover {
  border: none;
  background-color: #eee;
}
div.contextPopup div.leaflet-popup-tip-container {
  //display:none;
}
</style>

<style scoped>
div.rastermap {
  margin: 10px 0px 10px 0px;
}
h4 {
  margin: 0px;
  padding: 8px;
  padding-left: 10px;
  font-size: 0.9em;
  width: 100%;
  color: #444;
}
h5 {
  font-size: 0.7em;
  color: #666;
  font-weight: 600;
  padding: 5px 0px 10px 0px;
  margin: 0px;
}
p {
  margin: 0px;
  font-size: 0.6em;
  color: #222;
}
p.attribution {
  font-size: 0.5em;
  padding: 0px 6px 3px 6px;
  color: #888;
}
div.cmd,
div.row {
  background-color: #f5f5f5;
}
a.btn-command:focus,
a.btn-command:active {
  outline: none !important;
  box-shadow: none;
}
a.btn-command {
  background-color: #f5f5f5;
  color: #999;
}
a.btn-command:hover {
  background-color: #eeeeee;
  color: #777;
}
a.btn-command i {
  font-size: 0.8em;
}
div.legend-wrapper {
  padding: 7px;
}
div.sidebar-contents strong {
  color: #444;
}
div.sidebar-contents {
  font-size: 0.8em;
  padding: 6px;
  margin: 0px;
}
div.sidebar-contents h4 {
  padding: 6px 4px 6px 4px;
  margin-top: 5px;
  font-size: 1.2em;
  font-weight: bold;
}
div.sidebar-contents table {
  margin: 0px;
  margin-bottom: 10px;
}
div.sidebar-contents table td {
  margin: 0px;
  padding: 1px 4px;
}

ul.cmd-group {
  display: inline;
  font-size: 0.65em;
  border: 1px solid #bbb;
  border-radius: 2px;
  padding: 0;
  margin: 0;
  margin-left: 5px;
  background-color: #fff;
}
ul.cmd-group li {
  display: inline-block;
  margin: 0px;
  padding: 4px 2px 4px 2px;
}
ul.cmd-group li a.active {
  color: rgb(21, 176, 26);
}
ul.cmd-group li.title {
  padding-left: 0px;
}
ul.cmd-group li.title a {
  background-color: #f5f5f5;
  border-right: 1px solid #ccc;
  padding-right: 4px;
  padding-left: 3px;
  color: #777;
}
ul.cmd-group li a {
  padding-left: 2px;
  padding-right: 2px;
  color: #bbb;
}
ul.cmd-group li a svg {
  color: #aaa;
}
ul.cmd-group a.icon {
  font-size: 0.9em;
}
ul.cmd-group a:hover {
  color: #777;
}

div.layer-selection {
  font-size: 1em;
}
div.layer-selection a.btn-layer {
  color: #007bff;
}
div.layer-selection a.active {
  background-color: #fff;
}
div.layer-selection a.btn-layer:hover {
  color: #0056b3;
}

div.layer-commands {
  font-size: 1em;
}
div.layer-commands a.btn-layer {
  color: #aaa;
}
div.layer-commands a.btn-layer:hover {
  color: #0056b3;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}

div.legend-description p {
  margin-bottom: 5px;
  font-size: 0.6em;
}
</style>
